export const StatusColors: Record<string, 'red' | 'orange' | 'blue' | 'green' | 'white'> = {
	Pending: 'orange',
	pending: 'orange',
	PendingAcceptance: 'orange',
	UnderReview: 'orange',
	PendingPayment: 'orange',
	Processing: 'orange',
	Standing: 'orange',
	Partial: 'orange',
	Ongoing: 'orange',
	PendingApproval: 'orange',
	Rejected: 'red',
	rejected: 'red',
	Canceled: 'red',
	Expired: 'red',
	Inactive: 'red',
	inactive: 'red',
	expired: 'red',
	terminated: 'red',
	Failed: 'red',
	Closed: 'red',
	Deleted: 'red',
	NotHeld: 'red',
	Blocked: 'red',
	Suspended: 'red',
	active: 'green',
	Active: 'green',
	Completed: 'green',
	completed: 'green',
	Success: 'green',
	Approved: 'green',
	Generated: 'green',
	Published: 'green',
	Distributed: 'green',
	accepted: 'green',
	Accepted: 'green',
	Yes: 'green',
	No: 'red',
	Abstained: 'orange',
	NoVote: 'blue',
	Reversed: 'blue',
	Scheduled: 'blue',
	WritingMinutes: 'blue',
	'': 'white',
};
